import React, { useState } from "react";
import EpignomeStyle from "./epigenopme.module.css";
import { Button, Col, Form, Input, Row, Select, Table, Carousel } from "antd";
import { ReactComponent as DownloadIcon } from "../../assets/icon/下载.svg";
import SelectOptions from "./json/compareSelect";
import DNA2Colums from "./json/DNA2Colums";

import { ReactComponent as LeftIcon } from "../../assets/icon/左 左.svg";
import { ReactComponent as RightIcon } from "../../assets/icon/右 右.svg";
import SwiperList from "./json/swiper";
import styled from "styled-components";
import http from "../../utils/http";
import Parrt_I from "./component/Part_I";
import Part_II from "./component/Part_II";
import Part_III from "./component/Part_III";

// 使用 styled-components 定义样式
const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #e3f2d9; // 修改表头背景颜色
    color: #333; // 修改表头文字颜色
    font-weight: bold; // 修改表头文字加粗
  }
`;

function Epigenome() {
  const [page, setPage] = useState(1);
  const [page_size, setpage_size] = useState(10);
  const [total, setTotal] = useState();
  const [CompareTable, setCompareTable] = useState([]);
  const [CompareColums, setCompareColums] = useState([]);
  const onFinish = (values) => {
    console.log(values);
    http
      .get(
        `/api/methy/dmr/?compare_varietys=${values.compare_varietys}&page=${page}&page_size=${page_size}`
      )
      .then((res) => {
        setTotal(res.count);
        let TempleCompareColums = [];
        Object.keys(res.results[0]).map((key) => {
          console.log(key);
          TempleCompareColums.push({
            title: key,
            dataIndex: key,
            key: key,
            align: "center",
          });
        });
        setCompareColums(TempleCompareColums);
        setCompareTable(res.results);
      })
      .catch((err) => {});
  };
  return (
    <div className={EpignomeStyle.Epigenome_app}>
      <div className={EpignomeStyle.Epigenome_Header}>
        <p>DNA methylation Search</p>
      </div>
      <Parrt_I />
      <div style={{height:"20px"}}></div>
     <Part_II/>
     <Part_III/>
    </div>
  );
}

export default Epigenome;
